const _excluded = ["options", "value", "onChange", "label", "labelSingular", "multiple", "placeholder"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { useTranslate } from 'react-polyglot';
import TextField from '../TextField';
import Field from '../../Field';
import { Badge, BadgeGroup } from '../../Badge';
import { Menu, MenuItem } from '../../Menu';
import { jsx as ___EmotionJSX } from "@emotion/react";
function SelectField(_ref) {
  var _label$;
  let {
      options,
      value,
      onChange,
      label,
      labelSingular,
      multiple,
      placeholder
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const t = useTranslate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElWidth, setAnchorElWidth] = useState();
  function handleOpenMenu(event) {
    setAnchorElWidth(`${event.currentTarget.offsetWidth}px`);
    setAnchorEl(event.currentTarget);
  }
  function handleClose(newValue) {
    if (!newValue) {
      setAnchorEl(null);
      return;
    }
    if (multiple) {
      const updatedValue = value && value.includes(newValue) ? value.filter(opt => opt !== newValue) : value ? [...value, newValue] : [newValue];
      onChange(updatedValue);
    } else {
      onChange(value === newValue ? null : newValue);
    }
    setAnchorEl(null);
  }
  const selection = options.find(option => option.value === value);
  const availableOptions = multiple && value ? options.filter(option => value.every(opt => opt.value !== option.value)) : options;
  return ___EmotionJSX(React.Fragment, null, multiple ? ___EmotionJSX(Field, _extends({}, props, {
    onClick: handleOpenMenu,
    label: label,
    focus: !!anchorEl,
    icon: "chevron-down"
  }), value && value.length ? ___EmotionJSX(BadgeGroup, null, value.map(option => ___EmotionJSX(Badge, {
    key: option.value,
    onDelete: () => onChange(value.filter(opt => opt !== option))
  }, options.find(opt => opt.value === option).label))) : ___EmotionJSX("span", null, placeholder || t('editor.editorWidgets.select.placeholder', {
    label: label.toLowerCase()
  }))) : ___EmotionJSX(TextField, _extends({}, props, {
    readOnly: true,
    label: labelSingular || label,
    onClick: handleOpenMenu,
    focus: !!anchorEl,
    value: options && (selection === null || selection === void 0 ? void 0 : selection.label),
    placeholder: placeholder || t('editor.editorWidgets.select.placeholder', {
      label: labelSingular.toLowerCase() || label.toLowerCase()
    }),
    icon: "chevron-down"
  })), options && ___EmotionJSX(Menu, {
    anchorOrigin: {
      x: 'center',
      y: 'bottom'
    },
    transformOrigin: {
      x: 'center',
      y: 'top'
    },
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: () => handleClose(),
    width: anchorElWidth
  }, availableOptions.length ? availableOptions.map(option => ___EmotionJSX(MenuItem, {
    selected: multiple ? value && value.includes(option.value) : value === option.value,
    onClick: () => handleClose(option.value),
    key: option.value
  }, option.label)) : ___EmotionJSX(MenuItem, {
    disabled: true
  }, "No ", (label === null || label === void 0 || (_label$ = label[0]) === null || _label$ === void 0 ? void 0 : _label$.toLowerCase()) + (label === null || label === void 0 ? void 0 : label.slice(1)), " to select.")));
}
export default SelectField;